import * as React from "react";
import useBoxReturn from "boxReturn/useBoxReturn";

export default function LoadingIndicator() {
  const { isLoading } = useBoxReturn();
  if (!isLoading) return null;
  return <div>loading...</div>;
}
